import { isWaitlistedListing } from '@/src/components/features/property/lib/waitlist';
import type { ContactFormMode } from './types';

export type ContactSubmitLabelKey = 'submitApply' | 'submitTour' | 'submitWaitlist' | 'submitContact';
export type ContactTitleKey = 'titleWaitlist' | 'titleContact';

/**
 * The `contactForm` message key for the button that actually sends the inquiry.
 *
 * Shared rather than inlined because three places have to agree on it: the button itself, the
 * legal footnote next to it (`legalTrail` interpolates the label into "When you click X, we'll
 * send your inquiry…"), and `message_property_manager`, which tells the agent which button to
 * hand the renter. A hardcoded label in any of them is wrong on a waitlisted listing — where this
 * resolves to "Add me to the waitlist" — and wrong in every non-English locale.
 */
export function contactSubmitLabelKey(mode: ContactFormMode, listing: unknown): ContactSubmitLabelKey {
  if (mode === 'requestToApply') return 'submitApply';
  if (mode === 'tour') return 'submitTour';
  if (isWaitlistedListing(listing)) return 'submitWaitlist';
  return 'submitContact';
}

/** The `contactForm` message key for the dialog's own heading. Shared for the same reason. */
export function contactTitleKey(listing: unknown): ContactTitleKey {
  return isWaitlistedListing(listing) ? 'titleWaitlist' : 'titleContact';
}
